import { useState } from 'react';
import { useIntl } from 'react-intl';
import logExploreTrailCardListActionTaken from '@alltrails/amplitude/events/logExploreTrailCardListActionTaken';
import Dropdown from '@alltrails/denali/components/Dropdown';
import DropdownMenu from '@alltrails/denali/components/DropdownMenu';
import { updateExploreActionType, updateSort } from '@alltrails/explore-service/redux/exploreServiceSlice';
import { exploreServiceSortDisplayOrder } from '@alltrails/explore-service/utils/constants';
import getExploreServiceSortLabel from '@alltrails/explore-service/utils/getExploreServiceSortLabel';
import { getSortingAction } from '@/utils/analyticsHelpers';
import { useAppDispatch, useAppSelector } from '@/utils/redux';
import styles from './SortDropdown.module.scss';

const SortDropdown = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const { exploreServiceSort } = useAppSelector(state => ({
    exploreServiceSort: state.exploreService.sort
  }));

  const [isSortDropdownOpen, setIsSortDropdownOpen] = useState(false);

  return (
    <DropdownMenu
      anchor={
        <Dropdown
          className={styles.dropdown}
          text={getExploreServiceSortLabel(intl, exploreServiceSort)}
          variant="flat"
          size="sm"
          onClick={() => setIsSortDropdownOpen(!isSortDropdownOpen)}
          aria-expanded={isSortDropdownOpen}
          aria-haspopup="menu"
        />
      }
      className={styles.sortDropdown}
      isOpen={isSortDropdownOpen}
      onCloseRequest={() => setIsSortDropdownOpen(false)}
      options={exploreServiceSortDisplayOrder.map(sort => ({
        key: sort,
        onClick: () => {
          logExploreTrailCardListActionTaken({
            action_taken: 'sorted',
            sorting_action: getSortingAction(sort)
          });
          dispatch(updateExploreActionType('filter applied'));
          dispatch(updateSort(sort));
          setIsSortDropdownOpen(false);
        },
        selected: sort === exploreServiceSort,
        title: getExploreServiceSortLabel(intl, sort)
      }))}
      placement="bottom-end"
    />
  );
};

export default SortDropdown;
